import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import MyProfileAddressSkeleton from "../../../Skeleton/myWallet/myProfileAddressSkeleton";

export const ShippingAddressCard = () => {
  const { shippingAddressOriginal } = useContext(GlobalContext);
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(shippingAddressOriginal);
  }, [shippingAddressOriginal]);
  return (
    <div className="col-sm-6">
      <div className="order-address">
        <div className="card order-address-card">
          <div className="card-header">
            <h5>
              <span className="wes wes-shipping-truck" />
              Shipping Address
            </h5>
          </div>
          {data ? (
            <div className="card-body order-address-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="addressDetails">
                    <address className="text-dark">
                      <b>{data.shipTo}</b>
                      <br />
                      {data.shipAttention},
                      <br />
                      {data.shipAddress1},
                      <br />
                      {data.shipAddress2 && (
                        <>
                          {data.shipAddress2}
                          <br />,
                        </>
                      )}
                      {data.suburb},
                      <br />
                      {data.shipState}-{data.shipZip}, {data.shipCountry}
                    </address>
                    <div className="addressDetails-contact mt-3">
                      <p>
                        <b>Phone Number:</b> {data.shipPhone}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <MyProfileAddressSkeleton />
          )}
        </div>
      </div>
    </div>
  );
};
